
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("eK5zz", function(module, exports) {

$parcel$export(module.exports, "Panel", () => $57f246d928e48214$export$2ddb90ad54e5f587);
/* panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $bWLcG = parcelRequire("bWLcG");

var $dEIJ1 = parcelRequire("dEIJ1");

var $K0HEo = parcelRequire("K0HEo");

var $8jREP = parcelRequire("8jREP");

var $dGAIk = parcelRequire("dGAIk");

var $bgZhH = parcelRequire("bgZhH");

var $c9vFp = parcelRequire("c9vFp");

var $dh62b = parcelRequire("dh62b");

var $38bxn = parcelRequire("38bxn");
const $57f246d928e48214$var$panelSplitterResizingVar = '--n_pnlRsz'; /**
                                                * The bounds for Aside and Panel are purposely set to support the current usage in Jira.
                                                *
                                                * Jira sets the slot's width to `0px` when there is no active content to display in it.
                                                *   - This means the min width needs to support `0px`.
                                                * The Conversation Assistant component in Jira (rendered in a nav3 RightSidebar, or a nav4 Aside) has a custom resizing
                                                * implementation, which has a maximum width of `50vw`.
                                                *   - This means the max width needs to support `50vw`.
                                                *
                                                * This is not the final implementation and will be updated once Jira's usage has been fixed.
                                                * Ticket to track this is: https://jplat.atlassian.net/browse/BLU-3951
                                                *
                                                * We're using two different bounds for each slot here, to support the `0px` min width when programatically set using the
                                                * `defaultWidth` prop, and another one that is used when resizing the slots which has a sensible min width.
                                                */ 
const $57f246d928e48214$var$oldPanelWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $57f246d928e48214$var$oldPanelWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
function $57f246d928e48214$var$getOldResizeBounds() {
    return $57f246d928e48214$var$oldPanelWidthResizeBounds;
} /**
   * We typically use the `defaultWidth` as the minimum resizing width,
   * but for large default widths we fallback to a standard value.
   *
   * This standard value of `400px` is to align with the Global Preview Panels.
   */ 
const $57f246d928e48214$var$fallbackResizeMinWidth = 400;
const $57f246d928e48214$var$styles = {
    root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3i1run _kqsw1if8 _152t1l7u _1bsb1adv _14b54rrg _1dhy1c6w _9sns1wug",
    backgroundColor: "_bfhk1bhr _4ap3vuon",
    border: "_191woyrj _16qs1cd0 _z8dmmuej _scbpglyw",
    scrollContainer: "_1reo1wug _18m91wug _4t3i1osq",
    hidden: "_1e0cglyw"
}; /**
    * The Panel layout area is rendered to the right (inline end) of the Main area, or the Aside area if it is present.
    *
    * On small viewports (below 64rem, or 1024px), the Panel slot will become an overlay.
    *
    * You can optionally render a `PanelSplitter` as a child to make the panel area resizable.
    */ 
function $57f246d928e48214$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidth = 365, label: label = 'Panel', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId, xcss: xcss, hasBorder: hasBorder = (0, $dh538.fg)('platform_design_system_nav4_panel_default_border') }) {
    const dangerouslyHoistSlotSizes = (0, $gwFzn.useContext)((0, $8jREP.DangerouslyHoistSlotSizes));
    const id = (0, $bgZhH.useLayoutId)({
        providedId: providedId
    }); /**
       * Don't show the skip link if the slot has 0 width.
       *
       * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
       */ 
    (0, $dEIJ1.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0
    });
    const ref = (0, $gwFzn.useRef)(null);
    const [width, setWidth] = (0, $gwFzn.useState)(defaultWidth); // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const defaultWidthRef = (0, $gwFzn.useRef)(defaultWidth); /**
                                                 * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
                                                 * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
                                                 * https://jplat.atlassian.net/browse/BLU-3951
                                                 */ 
    (0, $gwFzn.useEffect)(()=>{
        if (defaultWidthRef.current === defaultWidth) return;
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    const sideNavRef = (0, $dh62b.useSideNavRef)(); /**
                                       * The minimum width that the panel can be resized to by the user.
                                       *
                                       * We only use the `defaultWidth` up to a point to avoid huge panels.
                                       */ 
    const minWidth = Math.min(defaultWidth, $57f246d928e48214$var$fallbackResizeMinWidth);
    const getNewResizeBounds = (0, $gwFzn.useCallback)(()=>{
        const sideNavWidth = sideNavRef.current?.offsetWidth ?? 0; /**
                                                                * The panel should not resize larger than the page content, equivalent to the `Main` + `Aside` slots.
                                                                *
                                                                * This maximum width is equivalent to half the viewport width, after removing the sidebar width.
                                                                */ 
        const maxWidth = Math.round((window.innerWidth - sideNavWidth) / 2);
        return {
            min: `${minWidth}px`,
            max: `${maxWidth}px`
        };
    }, [
        minWidth,
        sideNavRef
    ]);
    const panelWidthSlotBounds = (0, $dh538.fg)('platform_design_system_nav4_preview_panel_support') ? {
        min: `${minWidth}px`,
        // `sideNavLiveWidthVar` is not defined if the `SideNav` is not mounted, so we fallback to `0px`.
        max: `round(nearest, calc((100vw - var(${0, $K0HEo.sideNavLiveWidthVar}, 0px)) / 2), 1px)`
    } : $57f246d928e48214$var$oldPanelWidthSlotBounds;
    const panelVariableWidth = `clamp(${panelWidthSlotBounds.min}, ${width}px, ${panelWidthSlotBounds.max})`;
    (0, $38bxn.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes && (0, $dh538.fg)('platform_design_system_nav4_live_resizing_css_vars'),
        cssVar: $57f246d928e48214$var$panelSplitterResizingVar,
        panelId: (0, $K0HEo.panelPanelSplitterId)
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("section", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $35pXk.default)([
            $57f246d928e48214$var$styles.root,
            defaultWidth === 0 && $57f246d928e48214$var$styles.hidden,
            hasBorder && $57f246d928e48214$var$styles.border,
            (0, $dh538.fg)('platform_design_system_nav4_panel_default_bg_color') && $57f246d928e48214$var$styles.backgroundColor,
            xcss
        ]),
        style: {
            [(0, $K0HEo.panelVar)]: panelVariableWidth
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dGAIk.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $K0HEo.UNSAFE_panelLayoutVar),
                value: "0px",
                mediaQuery: (0, $bWLcG.media).above.lg,
                responsiveValue: (0, $dh538.fg)('platform_design_system_nav4_live_resizing_css_vars') ? `var(${$57f246d928e48214$var$panelSplitterResizingVar}, ${panelVariableWidth})` : panelVariableWidth
            }) // ------ END UNSAFE STYLES ------
            ,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c9vFp.PanelSplitterProvider), {
                panelId: (0, $K0HEo.panelPanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: (0, $dh538.fg)('platform_design_system_nav4_preview_panel_support') ? getNewResizeBounds : $57f246d928e48214$var$getOldResizeBounds,
                resizingCssVar: $57f246d928e48214$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                    className: (0, $35pXk.default)([
                        $57f246d928e48214$var$styles.scrollContainer
                    ]),
                    children: children
                })
            })
        ]
    });
}

});
parcelRegister("c9vFp", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterProvider", () => $e2e4277b85ba6dcf$export$f662bfb764348932);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $83Hmc = parcelRequire("83Hmc");
const $e2e4277b85ba6dcf$export$f662bfb764348932 = ({ panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, position: position = 'end', isEnabled: isEnabled = true, children: children })=>{
    const portalRef = (0, $gwFzn.useRef)(null);
    const context = (0, $gwFzn.useMemo)(()=>({
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            getResizeBounds: getResizeBounds,
            portalRef: portalRef,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled
        }), [
        panelId,
        panelWidth,
        onCompleteResize,
        getResizeBounds,
        resizingCssVar,
        position,
        panelRef,
        isEnabled
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $83Hmc.PanelSplitterContext).Provider, {
                value: context,
                children: children
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                ref: portalRef
            })
        ]
    });
};

});
parcelRegister("83Hmc", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterContext", () => $b95a4a31d7faedc2$export$7a4054f2c546f2cd);

var $gwFzn = parcelRequire("gwFzn");
const $b95a4a31d7faedc2$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $gwFzn.createContext)(null);

});


parcelRegister("38bxn", function(module, exports) {

$parcel$export(module.exports, "useResizingWidthCssVarOnRootElement", () => $7a27995d8faedf9c$export$d4931ecf0fbcc8fc);

var $gwFzn = parcelRequire("gwFzn");

var $bSjaC = parcelRequire("bSjaC");

var $4T4vf = parcelRequire("4T4vf");

var $bssir = parcelRequire("bssir");
function $7a27995d8faedf9c$export$d4931ecf0fbcc8fc({ isEnabled: isEnabled = true, cssVar: cssVar, panelId: panelId }) {
    (0, $gwFzn.useEffect)(()=>{
        if (!isEnabled) return;
        return (0, $bSjaC.combine)((0, $4T4vf.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.panelId === panelId;
            },
            onDrag ({ source: source }) {
                if (!(0, $bssir.isPanelSplitterDragData)(source.data)) return;
                /**
					 * Copies the resizing width value to the `<html>` element.
					 *
					 * Required to reflect the live width of the side navigation.
					 *
					 * Used by:
					 *   - Legacy `--leftSidebarWidth` variable
					 *   - Panel slot max-width constraint
					 *
					 * When the legacy `--leftSidebarWidth` variable is no longer needed,
					 * we could consider writing to the `Panel` element instead.
					 */ document.documentElement.style.setProperty(cssVar, source.data.resizingWidth);
            },
            onDrop () {
                document.documentElement.style.removeProperty(cssVar);
            }
        }));
    }, [
        cssVar,
        isEnabled,
        panelId
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!isEnabled) return;
        /**
		 * Ensures that the resizing CSS var on the `<html>` element is cleaned up properly
		 * if the component unmounts during a drag.
		 */ return function cleanupGlobalResizingCssVar() {
            document.documentElement.style.removeProperty(cssVar);
        };
    }, [
        cssVar,
        isEnabled
    ]);
}

});
parcelRegister("bssir", function(module, exports) {

$parcel$export(module.exports, "isPanelSplitterDragData", () => $0765ebec7270ae85$export$e239b3966b677000);
$parcel$export(module.exports, "PanelSplitter", () => $0765ebec7270ae85$export$db67e3f8d3d6da0f);
/* panel-splitter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $d8F95 = parcelRequire("d8F95");

var $4FhhO = parcelRequire("4FhhO");

var $5Uzw3 = parcelRequire("5Uzw3");

var $c0qxy = parcelRequire("c0qxy");

var $g6aM3 = parcelRequire("g6aM3");

var $6UUmP = parcelRequire("6UUmP");

var $dh538 = parcelRequire("dh538");

var $bSjaC = parcelRequire("bSjaC");

var $4T4vf = parcelRequire("4T4vf");
parcelRequire("lA2GQ");
var $l0s1Q = parcelRequire("l0s1Q");

var $5X6QO = parcelRequire("5X6QO");

var $gZctg = parcelRequire("gZctg");

var $6F6hl = parcelRequire("6F6hl");

var $83Hmc = parcelRequire("83Hmc");

var $5jaK5 = parcelRequire("5jaK5");

var $9nCrT = parcelRequire("9nCrT");

var $hghtD = parcelRequire("hghtD");

var $7FYAC = parcelRequire("7FYAC");

var $hSpqv = parcelRequire("hSpqv");
const $0765ebec7270ae85$var$containerStyles = {
    root: "_12ji1r31 _1qu2glyw _12y31o36 _1e0cglyw _kqswstnw _u7coidpf _152tidpf _1pbykb7n _181n1ule",
    positionEnd: "_rjxpftgi",
    positionStart: "_1e02zeo2"
};
const $0765ebec7270ae85$var$grabAreaStyles = {
    root: "_1bsbl52n _4t3i1osq _kqswstnw _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syaz3acm _bfhk18uv _k8m01ylx _1oec1yx9 _1lww5cps _d0aluf7j _1gavfnf5 _vp7gaqb7 _30l3aqb7 _1dr21ylx _1s5z1ylx _1cg4fnf5 _le1bfnf5 _1gglglyw _9h8h16c2"
};
const $0765ebec7270ae85$var$lineStyles = {
    root: "_kqswstnw _1e0c1ule _1bsbjfq9 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e021v6z"
};
const $0765ebec7270ae85$var$panelSplitterDragDataSymbol = Symbol('panel-splitter-drag-data');
function $0765ebec7270ae85$var$signPanelSplitterDragData(data) {
    return {
        ...data,
        [$0765ebec7270ae85$var$panelSplitterDragDataSymbol]: true
    };
}
function $0765ebec7270ae85$export$e239b3966b677000(data) {
    return data[$0765ebec7270ae85$var$panelSplitterDragDataSymbol] === true;
}
const $0765ebec7270ae85$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId })=>{
    const splitterRef = (0, $gwFzn.useRef)(null);
    const panelSplitterContext = (0, $gwFzn.useContext)((0, $83Hmc.PanelSplitterContext));
    (0, $5Uzw3.default)(panelSplitterContext, 'Panel splitter context must be set');
    const { panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, panelRef: panelRef, resizingCssVar: resizingCssVar, portalRef: portalRef, position: position, isEnabled: isEnabled } = panelSplitterContext;
    (0, $5Uzw3.default)(portalRef.current, 'Portal ref must be set');
    const direction = (0, $hSpqv.useTextDirection)(portalRef.current);
    const labelId = (0, $c0qxy.useId)(); // Separate state used for the input range width to remove the UI's dependency on the "persisted" layout state value being updated
    const [rangeInputValue, setRangeInputValue] = (0, $gwFzn.useState)(panelWidth); /**
                                                                       * We are using state to store the resize bounds _converted into pixel units_, so that we can update them when the window is resized.
                                                                       * Otherwise they can become out of sync with the actual viewport size, and cause a broken experience (inaccurate width percentage)
                                                                       * when the user tries to resize using the keyboard.
                                                                       */ 
    const [rangeInputBounds, setRangeInputBounds] = (0, $gwFzn.useState)({
        // Using placeholder values here for the initial render. These will be calculated and updated when the range input is focused.
        min: 200,
        max: 500
    });
    const openLayerObserver = (0, $6UUmP.useOpenLayerObserverBehindFG)();
    (0, $gwFzn.useEffect)(()=>{
        if (!isEnabled) return;
        const splitter = splitterRef.current;
        (0, $5Uzw3.default)(splitter, 'Splitter ref must be set');
        return (0, $bSjaC.combine)((0, $l0s1Q.blockDraggingToIFrames)({
            element: splitter
        }), (0, $4T4vf.draggable)({
            element: splitter,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $5X6QO.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                }); // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $gZctg.preventUnhandled).start();
            },
            getInitialData () {
                (0, $5Uzw3.default)(panelRef.current, 'Panel ref must be set');
                const initialWidth = (0, $hghtD.getPixelWidth)(panelRef.current); /**
                                                               * The drag calculations require the actual computed width of the element
                                                               * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
                                                               * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
                                                               */ 
                return $0765ebec7270ae85$var$signPanelSplitterDragData({
                    panelId: panelId,
                    initialWidth: initialWidth,
                    resizingWidth: `${initialWidth}px`,
                    resizeBounds: getResizeBounds()
                });
            },
            onDragStart ({ source: source }) {
                (0, $5Uzw3.default)($0765ebec7270ae85$export$e239b3966b677000(source.data));
                onResizeStart?.({
                    initialWidth: source.data.initialWidth
                }); // Close any open layers when the user starts resizing
                if ((0, $dh538.fg)('platform_dst_open_layer_observer_close_layers')) openLayerObserver?.closeLayers();
            },
            onDrag ({ location: location, source: source }) {
                (0, $5Uzw3.default)($0765ebec7270ae85$export$e239b3966b677000(source.data));
                const { initialWidth: initialWidth, resizeBounds: resizeBounds } = source.data; /**
                          * How wide the element would be if there were no width constraints,
                          * based on the pointer's position.
                          */ 
                const targetWidth = (0, $hghtD.getWidthFromDragLocation)({
                    initialWidth: initialWidth,
                    location: location,
                    direction: direction,
                    position: position
                });
                const resizingWidth = `clamp(${resizeBounds.min}, ${targetWidth}px, ${resizeBounds.max})`;
                panelRef.current?.style.setProperty(resizingCssVar, resizingWidth);
                source.data.resizingWidth = resizingWidth;
            },
            onDrop ({ source: source }) {
                (0, $5Uzw3.default)($0765ebec7270ae85$export$e239b3966b677000(source.data));
                (0, $gZctg.preventUnhandled).stop();
                (0, $5Uzw3.default)(panelRef.current, 'Panel ref must be set');
                (0, $5Uzw3.default)($0765ebec7270ae85$export$e239b3966b677000(source.data));
                const finalWidth = (0, $hghtD.getPixelWidth)(panelRef.current);
                onCompleteResize(finalWidth);
                onResizeEnd?.({
                    initialWidth: source.data.initialWidth,
                    finalWidth: finalWidth
                });
                panelRef.current.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStart,
        onResizeEnd,
        panelRef,
        resizingCssVar,
        panelWidth,
        direction,
        position,
        isEnabled,
        openLayerObserver,
        panelId,
        getResizeBounds
    ]);
    const onResizeStartStableRef = (0, $g6aM3.default)(onResizeStart);
    const onResizeEndStableRef = (0, $g6aM3.default)(onResizeEnd);
    const [keyboardResizeManager] = (0, $gwFzn.useState)(()=>(0, $7FYAC.createKeyboardResizeManager)({
            onResizeStart: (...args)=>{
                // Close any open layers when the user starts resizing with keyboard
                if ((0, $dh538.fg)('platform_dst_open_layer_observer_close_layers')) openLayerObserver?.closeLayers();
                onResizeStartStableRef.current?.(...args);
            },
            onResizeEnd: (...args)=>onResizeEndStableRef.current?.(...args)
        }));
    const handleSliderInputChange = (0, $gwFzn.useCallback)((event)=>{
        const value = parseInt(event.target.value);
        setRangeInputValue(value); /**
                                * We are intentionally _not_ debouncing `onCompleteResize` as we want it to be called anytime the user changes the range input value.
                                * It is an internal-only callback - it's provided by `PanelSplitterProvider`, and used by layout slots to update their layout width state.
                                */ 
        onCompleteResize(value);
        keyboardResizeManager.onResize({
            initialWidth: panelWidth,
            finalWidth: value
        });
    }, [
        onCompleteResize,
        panelWidth,
        keyboardResizeManager
    ]);
    const resizeEventListenerCleanupFn = (0, $gwFzn.useRef)(null);
    const handleSliderFocus = (0, $gwFzn.useCallback)(()=>{
        /**
     * We are only updating the range input's properties when the element is focused, as a performance optimisation.
     * It isn't necessary to recalculate these values until the element is going to be used.
     */ // Clean up any left over listeners in case `focus` was triggered again without `blur`.
        resizeEventListenerCleanupFn.current?.(); // Update the range input value to match the current panel width.
        setRangeInputValue(panelWidth);
        const resizeBounds = getResizeBounds(); // Update the range input bounds to ensure they are accurate (in case the viewport was previously resized)
        setRangeInputBounds({
            min: (0, $5jaK5.convertResizeBoundToPixels)(resizeBounds.min),
            max: (0, $5jaK5.convertResizeBoundToPixels)(resizeBounds.max)
        }); /**
         * _While the slider element is focused_, add a window resize event listener to update the range input bounds
         * when the window is resized. This is needed to ensure the min and max widths accurately reflect the viewport
         * size - in case they are provided in vw units.
         *
         * This listener is cleaned up when the element is blurred.
         */ 
        resizeEventListenerCleanupFn.current = (0, $d8F95.bind)(window, {
            type: 'resize',
            listener: function updateState() {
                const resizeBounds = getResizeBounds();
                setRangeInputBounds({
                    min: (0, $5jaK5.convertResizeBoundToPixels)(resizeBounds.min),
                    max: (0, $5jaK5.convertResizeBoundToPixels)(resizeBounds.max)
                });
            }
        });
    }, [
        panelWidth,
        getResizeBounds
    ]);
    const handleSliderBlur = (0, $gwFzn.useCallback)(()=>{
        // Remove the resize event listener when the range input is blurred.
        resizeEventListenerCleanupFn.current?.();
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        return function cleanup() {
            // Cleanup the resize event listener when the component is unmounted.
            resizeEventListenerCleanupFn.current?.();
        };
    }, []);
    const ariaValueText = (0, $gwFzn.useMemo)(()=>`${(0, $9nCrT.getPercentageWithinPixelBounds)({
            currentWidth: rangeInputValue,
            resizeBounds: rangeInputBounds
        })}% width`, [
        rangeInputValue,
        rangeInputBounds
    ]);
    if (!isEnabled) return null;
    return /*#__PURE__*/ (0, $4FhhO.createPortal)(/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        className: (0, $35pXk.default)([
            $0765ebec7270ae85$var$containerStyles.root,
            position === 'start' && $0765ebec7270ae85$var$containerStyles.positionStart,
            position === 'end' && $0765ebec7270ae85$var$containerStyles.positionEnd
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
            ref: splitterRef,
            "data-testid": testId,
            className: (0, $35pXk.default)([
                $0765ebec7270ae85$var$grabAreaStyles.root
            ]),
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6F6hl.default), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("input", {
                            type: "range",
                            value: rangeInputValue,
                            step: 20,
                            min: rangeInputBounds.min,
                            max: rangeInputBounds.max,
                            "aria-valuetext": ariaValueText,
                            "aria-labelledby": labelId,
                            onChange: handleSliderInputChange,
                            onFocus: handleSliderFocus,
                            onBlur: handleSliderBlur
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                            id: labelId,
                            children: label
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                    className: (0, $35pXk.default)([
                        $0765ebec7270ae85$var$lineStyles.root
                    ])
                })
            ]
        })
    }), portalRef.current);
};
// Ensures that the component is only rendered on a client. Uses a `useEffect`, which is not run on servers.
const $0765ebec7270ae85$var$ClientOnly = ({ children: children })=>{
    const [hasMounted, setHasMounted] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        setHasMounted(true);
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
        children: hasMounted ? children : null
    });
}; /**
    * _PanelSplitter_
    *
    * A component that allows the user to resize a layout area.
    * It can be used within layout areas like `SideNav`, `Panel`, and `Aside`. The layout area component should
    * provide the context for it using `<PanelSplitterProvider>`.
    *
    * Example usage in products:
    * ```tsx
    * <SideNav>
    *   {/* other side nav content *}
    *   <PanelSplitter label="Resize Side Nav" />
    * </SideNav>
    * ```
    */ 
const $0765ebec7270ae85$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId })=>/*#__PURE__*/ (0, $7UHDa.jsx)($0765ebec7270ae85$var$ClientOnly, {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($0765ebec7270ae85$var$PortaledPanelSplitter, {
            label: label,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd,
            testId: testId
        })
    });

});
parcelRegister("6UUmP", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserver", () => $99f6c5f63009a988$export$750f5b0d6c51617e);
$parcel$export(module.exports, "useOpenLayerObserverBehindFG", () => $99f6c5f63009a988$export$e9cbca62806a89c8);

var $gwFzn = parcelRequire("gwFzn");

var $5Uzw3 = parcelRequire("5Uzw3");

var $dh538 = parcelRequire("dh538");

var $iHNqU = parcelRequire("iHNqU");
function $99f6c5f63009a988$export$750f5b0d6c51617e() {
    const context = (0, $gwFzn.useContext)((0, $iHNqU.OpenLayerObserverContext));
    (0, $5Uzw3.default)(context, 'useOpenLayerObserver must be used within an OpenLayerObserver');
    const publicAPI = (0, $gwFzn.useMemo)(()=>({
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        }), [
        context.getCount,
        context.onChange,
        context.closeLayers
    ]);
    return publicAPI;
}
function $99f6c5f63009a988$export$e9cbca62806a89c8() {
    const context = (0, $gwFzn.useContext)((0, $iHNqU.OpenLayerObserverContext));
    const publicAPI = (0, $gwFzn.useMemo)(()=>{
        if (!(0, $dh538.fg)('platform_dst_open_layer_observer_close_layers')) return null;
        if (!context) return null;
        return {
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        };
    }, [
        context
    ]);
    return publicAPI;
}

});

parcelRegister("lA2GQ", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => (parcelRequire("l0s1Q")).blockDraggingToIFrames);

var $l0s1Q = parcelRequire("l0s1Q");

});
parcelRegister("l0s1Q", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => $781e3b2f1e0ef26e$export$6ae1d8fab001518c);

var $3CnSH = parcelRequire("3CnSH");

var $bSwyQ = parcelRequire("bSwyQ");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $781e3b2f1e0ef26e$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
let $781e3b2f1e0ef26e$var$isActive = false;
/**
 * Start blocking dragging to iframes. Only to be called once a drag has started.
 */ function $781e3b2f1e0ef26e$var$tryStart() {
    // There can technically be multiple registrations on the same element.
    // Adding a guard to ensure that only one registration does the blocking.
    if ($781e3b2f1e0ef26e$var$isActive) return;
    $781e3b2f1e0ef26e$var$isActive = true;
    // At this stage, we are also not watching for new iframe elements being added to the page
    // (we _could_ do that as a future change)
    const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$781e3b2f1e0ef26e$var$setStyle(iframe, {
            property: 'pointer-events',
            rule: 'none',
            priority: 'important'
        }));
    // Not returning the cleanup function.
    // This code will clean itself up when the interaction ends in `onDrop()`.
    // Once a drag has started we are blocking iframes until the interaction is finished.
    const cleanup = (0, $bSwyQ.combine)(...iframeCleanups, // We only need this monitor for listening to the drop
    // as our monitor in `blockDraggingToIFrames()` will only
    // call this function when the drag has started
    (0, $3CnSH.monitorForElements)({
        onDrop () {
            cleanup();
        }
    }), function release() {
        $781e3b2f1e0ef26e$var$isActive = false;
    });
}
function $781e3b2f1e0ef26e$export$6ae1d8fab001518c({ element: element }) {
    return (0, $3CnSH.monitorForElements)({
        onGenerateDragPreview ({ source: source }) {
            // only starting if we are dragging the provided element
            if (source.element === element) $781e3b2f1e0ef26e$var$tryStart();
        }
    });
}

});


parcelRegister("5jaK5", function(module, exports) {

$parcel$export(module.exports, "convertResizeBoundToPixels", () => $5c11e49c5c74abb4$export$3d412b3011b66f82);
function $5c11e49c5c74abb4$export$3d412b3011b66f82(resizeBound) {
    if (resizeBound.endsWith('vw')) {
        // Max width was provided in `vw` units, so is relative to the viewport width.
        // e.g. 50vw = 50% of the viewport width.
        // `parseInt` will remove the `vw` suffix.
        const maxWidthFraction = parseInt(resizeBound) / 100;
        return Math.floor(window.innerWidth * maxWidthFraction);
    }
    // Max width was provided in `px` units, so we can parse it directly.
    // `parseInt` will remove the `px` suffix.
    return Math.floor(parseInt(resizeBound));
}

});

parcelRegister("9nCrT", function(module, exports) {

$parcel$export(module.exports, "getPercentageWithinPixelBounds", () => $dff022be7a6bc7d7$export$b5423678cdf09f5);
function $dff022be7a6bc7d7$export$b5423678cdf09f5({ currentWidth: currentWidth, resizeBounds: resizeBounds }) {
    const resizeRange = resizeBounds.max - resizeBounds.min;
    const widthAsPercentage = (currentWidth - resizeBounds.min) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}

});

parcelRegister("hghtD", function(module, exports) {

$parcel$export(module.exports, "getWidthFromDragLocation", () => $8ef9fde1e356a95a$export$e360234971cb95b8);
$parcel$export(module.exports, "getPixelWidth", () => $8ef9fde1e356a95a$export$d942790ad00c41f9);
const $8ef9fde1e356a95a$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, direction: direction, position: position })=>{
    const diffX = location.current.input.clientX - location.initial.input.clientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
};
const $8ef9fde1e356a95a$export$d942790ad00c41f9 = (element)=>{
    const { width: width } = window.getComputedStyle(element);
    return parseInt(width);
};

});

parcelRegister("7FYAC", function(module, exports) {

$parcel$export(module.exports, "createKeyboardResizeManager", () => $b29e9f9401610bc8$export$f7d3d5dae65f74aa);
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $b29e9f9401610bc8$var$resizeCallbackDebounceTimeMs = 500;
function $b29e9f9401610bc8$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
	 * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
	 */ function startResizeEndTimer({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            resizingState = {
                type: 'idle'
            };
        }, $b29e9f9401610bc8$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: initialWidth,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart({
                initialWidth: initialWidth
            });
            startResizeEndTimer({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                initialWidth: resizingState.initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
    }
    return {
        onResize: onResize
    };
}

});

parcelRegister("hSpqv", function(module, exports) {

$parcel$export(module.exports, "useTextDirection", () => $6048c8c412d5be2b$export$cf24a79f32f45545);

var $gwFzn = parcelRequire("gwFzn");
const $6048c8c412d5be2b$export$cf24a79f32f45545 = (element)=>(0, $gwFzn.useMemo)(()=>{
        const { direction: direction } = window.getComputedStyle(element);
        return direction === 'rtl' ? 'rtl' : 'ltr';
    }, [
        element
    ]);

});





//# sourceMappingURL=PageLayout.1980cf96.js.map
